export default __webpack_public_path__ + "static/media/evreux4.58ea1645.jpg";